/*
 * module.js - The description of the module.
 */

Fundu.Components.Settings = (function($) {

    // State
    ///////////////////////////
    var _isInitialized = false;

    // Properties
    ///////////////////////////
    var _emailElement = false;
    var _emailValidateElement = false;

    var _passwordElement = false;
    var _passwordValidateElement = false;

    var _confirmElement = false;
    var _confirmValidateElement = false;

    var _passwordStrength = false;
    var _passwordInstructions = false;

    var _ibanElement = false;
    var _ibanValidationElement = false;

    var _saveButton = false;

    var _error = false;
    var _lockState = false;
    var _everythingOk = true;

    var _oldValues = false;


    // Private Methods
    ///////////////////////////

    // Select elements from HTML
    var selectElements = function() {
        _emailElement = $("#email");
        _emailValidateElement = $("#email").parent().find('.validation');

        _passwordElement = $("#password");
        _passwordValidateElement = $("#password").parent().find('.validation');

        _confirmElement = $("#confirmPassword");
        _confirmValidateElement = $("#confirmPassword").parent().find('.validation');

        _passwordStrength = $("#passwordStrength");
        _passwordInstructions = $('.password.instructions .validate');

        _ibanElement = $('#iban');
        _ibanValidationElement = $('#iban').parent().find('.validation');

        _saveButton = $('#actions .save.btn');
    }

    // Check that the elements exist and unbind them
    var checkElements = function() {

        // Update e-mail validation if exists
        if( _emailValidateElement.length > 0 )
            _emailElement.on('keyup', checkEmail);

        // Update progress bar and validation result on each keypress of password input if they exists
        if( _passwordValidateElement.length > 0 && _passwordStrength.length > 0 )
             _passwordElement.on('keyup', checkPassword);

        // Update password confirmations validation if it has one
        if( _confirmValidateElement.length > 0 )
            _confirmElement.on('keyup', checkPassword);

        // Update password confirmations validation if it has one
        if( _ibanValidationElement.length > 0 )
            _ibanElement.on('keyup', checkIBAN);

        _saveButton.on('click', saveSettings);
        _oldValues = {};

        $('.settings.row input').each(
                function(index){
                    var name = $(this).attr('id');
                    if( name !== "taxPrepayment" && name !== "marketingOptIn" && name !== "investorMonthlyOptIn"){
                        _oldValues[ name ] = $(this).val();
                    }else{
                        if( $(this).prop( "checked" ) )
                            _oldValues[ name ] = true;
                        else {
                            _oldValues[ name ] = false;
                        }
                    }
                }
        );

        // Try to account for autofill incase it is active (even if ti shouldn't!!)
        setTimeout( function(){
            if( _emailValidateElement.length > 0 )
                checkEmail.call(_emailElement.first());

            if( _passwordValidateElement.length > 0 && _passwordStrength.length > 0 )
                checkPassword.call(_passwordElement.first());

            if( _confirmValidateElement.length > 0 )
                checkPassword.call(_confirmElement.first());

            if( _ibanValidationElement.length > 0 )
                checkIBAN.call(_ibanElement);
        }, 800);

        return true;
    }

    var lock = function(area) {
        $(".settings.row").addClass("processing");
    }

    var unlock = function(area) {
        $(".settings.row").removeClass("processing");
    }


    var checkEmail = function(ev) {

        var result = Fundu.Helpers.Validate.email(_emailElement.val());

        setTimeout(function(){
            if(result){
                var className = "success";
            }
            else{
                var className = "fail";
            }

            _emailValidateElement.attr("class", className + " validation");
        }, 80);

        // When used from startRegister
        if(typeof ev === "undefined" )
            return result;
    }

    // Check password
    var checkPassword = function(ev) {
        // 1. Validate password
        // 2. Check confirm password
        var password = _passwordElement.val();
        var confirmValue = _confirmElement.val();
        var result = false;
        var valid = false;

        if(password){
            valid = Fundu.Helpers.Validate.password(password)
            result = zxcvbn(password);
        }

        if(_confirmValidateElement.length > 0){
            var confirm = "fail";
            // We check also for empty
            if(confirmValue !== "" && password === confirmValue)
                confirm = "success";
        }

        setTimeout(function(){
            if(valid && result){
                if(result.score < 3){
                    _passwordValidateElement.attr("class", "warning validation");
                }
                else{
                    _passwordValidateElement.attr("class", "success validation");
                }
                _passwordStrength.attr('class', "score-" + result.score + " password strength");

                if(confirm)
                    _confirmValidateElement.attr("class", confirm + " validation");

                if(_passwordInstructions)
                    _passwordInstructions.addClass("success");
                return true;
            }
            _passwordValidateElement.attr("class", "fail validation");
            _passwordStrength.attr('class', "error password strength");

            // Mark what parts of the password have failed
            if(_passwordInstructions){
                setTimeout(function(){
                    // We don't need to replace success with fail because the default state is fail
                    _passwordInstructions.removeClass("success");
                    var results = Fundu.Helpers.Validate.Test.password(password);

                    var passed = false;

                    for(var test in results){
                        if(results[test]){
                            if(!passed){
                                passed = "." + test;
                            } else {
                                passed = passed + ", ." + test;
                            }
                        }
                    }

                    if(passed){
                        _passwordInstructions.filter(passed).addClass("success");
                    }
                }, 80);
            }

            if(confirm)
                _confirmValidateElement.attr("class", confirm + " validation");
        }, 80);

        // When used from startRegister
        if(typeof ev === "undefined" ){
            if(password === "")
                return "missing";
            if(password !== confirmValue)
                return
            return ( valid && (confirmValue === password));
        }
    }

    var checkIBAN = function(ev){
        // Checkc IBAN with https://github.com/arhs/iban.js/tree/master
        var value = _ibanElement.val().replace(/\s/g, '');
        var result = IBAN.isValid(value);

        setTimeout(function(){
            if(result){
                var className = "success";
            }
            else{
                var className = "fail";
            }

            _ibanValidationElement.attr("class", className + " validation");
            // Force uppercase
            _ibanElement.val(_ibanElement.val().toUpperCase());
        }, 80);

        // When used from startRegister
        if(typeof ev === "undefined" )
            return result;
    }

    // Init
    ///////////////////////////
    var initialize = function() {
        if(_isInitialized) return true;

        selectElements();

        var success = checkElements();
        if (success) {
            _isInitialized = true;
            return true;
        }

        return false;
    }


    var updateContact = function(){

        var email = _emailElement.val();
        var phone = $("#phoneNumber").val();
        if( $('#marketingOptIn').prop("checked") ){
            var marketingOptIn = true;
        } else {
            var marketingOptIn = false;
        }
        if( $('#investorMonthlyOptIn').prop("checked") ){
            var investorMonthlyOptIn = true;
        } else {
            var investorMonthlyOptIn = false;
        }

        // Have values changed?
        if( _oldValues['email'] === email &&
            _oldValues['phoneNumber'] === phone &&
            _oldValues['marketingOptIn'] === marketingOptIn &&
            _oldValues['investorMonthlyOptIn'] === investorMonthlyOptIn ){
                return $.Deferred().resolve(false);
        }

        if (!phone) {
            Fundu.Helpers.Notify.error("contact", "error.phone.missing");
            return $.Deferred().resolve(false);
        } else if (!intlTelInputUtils.isValidNumber(phone)) {
            Fundu.Helpers.Notify.error("contact", "error.phone.notvalid");
            return $.Deferred().resolve(false);
        }

        // Confirm password check, must be === to password
        if (!email) {
            Fundu.Helpers.Notify.error("contact", "error.email.missing");
            return $.Deferred().resolve(false);
        } else if (!Fundu.Helpers.Validate.email(email)) {
            Fundu.Helpers.Notify.error("contact", "error.email.notvalid");
            return $.Deferred().resolve(false);
        }


        var data = {
            "email": email,
            "phone": phone.replace(/\s+/gi, ''),
            "marketingOptIn": marketingOptIn.toString(),
            "investorMonthlyOptIn": investorMonthlyOptIn.toString()
        };

        return $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            url: jsRoutes.controllers.SettingsCtrl.updateContact().url
        })

        .done(function(res) {
            if(!("success" in res)){
                Fundu.Helpers.Notify.error("console", "Error in response: " + res.responseText, true);
                Fundu.Helpers.Notify.error("settings", "error.generic");
                _error = true;
                _everythingOk = false;
                return false;
            }
        })

        .fail(function(res, error) {
            if (res.responseJSON && "error" in res.responseJSON) {
                Fundu.Helpers.Notify.error("contact", res.responseJSON.error);
            } else {
                _error = Fundu.Helpers.Defaults.Response.error("settings", error);
            }

            _everythingOk = false;
            return false;
        });
    }

    var updatePassword = function(){
        // Get data
        // Do data validation

        var password = _passwordElement.val();
        var confirmPassword = _confirmElement.val();

        // Was a password given
        if(password.length === 0){
            return $.Deferred().resolve(false);
        }

        if (!password) {
            Fundu.Helpers.Notify.error("password", "error.password.missing");
            return false;
        } else if (!Fundu.Helpers.Validate.password(password)) {
            Fundu.Helpers.Notify.error("password", "error.password.weak");
            return false;
        }

        // Confirm password check, must be === to password
        if (!confirmPassword) {
            Fundu.Helpers.Notify.error("password", "error.password.confirm.missing");
            return false;
        } else if (confirmPassword !== password) {
            Fundu.Helpers.Notify.error("password", "error.password.confirm.wrong");
            return false;
        }

        var data = {
            "password": password
        }

        return $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            url: jsRoutes.controllers.SettingsCtrl.updatePassword().url
        })

        .done(function(res) {
            if(!("success" in res)){
                Fundu.Helpers.Notify.error("console", "Error in response: " + res.responseText, true);
                Fundu.Helpers.Notify.error("settings", "error.generic");
                _error = true;
                _everythingOk = false;
                return false;
            }
        })

        .fail(function(res, error) {
            if (res.responseJSON && "error" in res.responseJSON) {
                Fundu.Helpers.Notify.error("password", res.responseJSON.error);
            } else {
                _error = Fundu.Helpers.Defaults.Response.error("settings", error);
            }

            _everythingOk = false;
            return false;
        });
    }

    var updateBankDetails = function(){

        // Checkc IBAN with https://github.com/arhs/iban.js/tree/master
        var iban = _ibanElement.val();
        if( !IBAN.isValid(iban) ){
            return $.Deferred().resolve(false);
        }

        if( $('#taxPrepayment').prop("checked") ){
            var checked = true;
        } else {
            var checked = false;
        }

        // Have values changed?
        if( _oldValues['iban'] === iban &&
            _oldValues['taxPrepayment'] === checked ){
                return $.Deferred().resolve(false);
        }

        var data = {
            "iban": iban.replace(/\s+/gi, '').toUpperCase(),
            "taxPrepaymentRegistered": checked.toString()
        }

        return $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            url: jsRoutes.controllers.SettingsCtrl.updateBankDetails().url
        })

        .done(function(res) {
            if(!("success" in res)) {
                Fundu.Helpers.Notify.error("console", "Error in response: " + res.responseText, true);
                Fundu.Helpers.Notify.error("settings", "error.generic");
                _error = true;
                _everythingOk = false;
                return false;
            }
        })

        .fail(function(res, error) {
            if (res.responseJSON && "error" in res.responseJSON) {
                Fundu.Helpers.Notify.error("iban", res.responseJSON.error);
            } else {
                _error = Fundu.Helpers.Defaults.Response.error("settings", error);
            }

            _everythingOk = false;
            return false;
        });
    }

    var updateAddress = function(){

        // Get data
        // Do data validation

        var street = $("#street").val();
        var zipCode = $("#postalCode").val();
        var city = $("#city").val();

        // Have values changed?
        if( _oldValues['street'] === street &&
            _oldValues['postalCode'] === zipCode &&
            _oldValues['city'] === city ){
                return $.Deferred().resolve(false);
        }

        if(!street || typeof street !== "string"){
            Fundu.Helpers.Notify.error("password", "error.address.missing");
            return false;
        }

        if(!zipCode || typeof zipCode !== "string"){
            Fundu.Helpers.Notify.error("password", "error.zipcode.missing");
            return false;
        }

        if(!city || typeof city !== "string"){
            Fundu.Helpers.Notify.error("password", "error.city.missing");
            return false;
        }

        var data = {
            "street": street,
            "postalCode": zipCode,
            "city": city
        }

        return $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            url: jsRoutes.controllers.SettingsCtrl.updateAddress().url
        })

        .done(function(res) {
            if(!("success" in res)){
                Fundu.Helpers.Notify.error("console", "Error in response: " + res.responseText, true);
                Fundu.Helpers.Notify.error("settings", "error.generic");
                _error = true;

                _everythingOk = false;
                return false;
            }
        })

        .fail(function(res, error) {
            if (res.responseJSON && "error" in res.responseJSON) {
                Fundu.Helpers.Notify.error("address", res.responseJSON.error);
            } else {
                _error = Fundu.Helpers.Defaults.Response.error("settings", error);
            }

            _everythingOk = false;
            return false;
        });
    }

    var saveSettings = function(ev){
        if(ev)
            ev.preventDefault();

        lock();
        _everythingOk = true;

        $.when( updateAddress(), updateContact(), updateBankDetails(), updatePassword() ).then(
            function(){
                unlock();
                if(_everythingOk && !_error){
                    Fundu.Helpers.Notify.success("global", "success.settings.save");
                }
            }
        )
    }

    // Public Methods
    ///////////////////////////

    return {
        init: initialize
    };

})(jQuery);
